import React from 'react';
import { connect } from 'react-redux';
import { Theme, Text, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../services/helpers";
import { useTheme } from '@mui/system';

/**
 *
 * @param {*} param0
 */
const HealthSpending = ({ amountSubmitted, amountClaimed, patient, completeClaim, useHSA, healthSpendRemaining }) => {
    const remaining = numberWithCommas((amountSubmitted - amountClaimed));
    const theme = useTheme();

    const styles = {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 500
        },
        main: {
            display: 'flex',
            flex: 1,
            overflow: 'auto',
            flexDirection: 'column',
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 20,
            paddingRight: 20
        },
        noBtn: {
            height: 60,
            borderRadius: 0
        },
        yesBtn: {
            height: 60,
            borderRadius: 0
        },
        btnBlock: {
            display: 'flex',
            flexDirection: 'row'
        }
    };

    return (
        <div style={ styles.container }>
            <div style={ styles.main }>
                <Text
                    align="center"
                    color={ Theme.colors.surface }
                    display="block"
                    largest
                >
                    { i18n.t(tokens.labels.claims.wantATopOff) }
                </Text>

                <Text
                    align="center"
                    color={ Theme.colors.surface }
                    display="block"
                    margin="20px 0 0 0"
                    medium
                >
                    { i18n.t(tokens.labels.claims.claimAmountDetails, { amountClaimed: numberWithCommas(amountClaimed), patient, remaining, healthSpendRemaining: healthSpendRemaining.toFixed(2) }) }
                </Text>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', height: 60 }}>
                <Button
                    onClick={completeClaim}
                    customStyle={ styles.noBtn }
                    fullWidth
                    color="white"
                >
                    <Text medium bold color={ Theme.colors.red }>{ i18n.t(tokens.buttons.no) }</Text>
                </Button>

                <Button
                    onClick={ useHSA }
                    customStyle={ styles.yesBtn }
                    fullWidth
                    color="white"
                >
                    <Text medium bold color={ theme.palette.primary.main }>{ i18n.t(tokens.buttons.yes) }</Text>
                </Button>
            </div>

        </div>
    );
};

export default connect()(HealthSpending);